import React, {useContext, useEffect, useRef, useState} from "react";
import {useHistory, withRouter} from "react-router";

import VehicleOfferListItem from "../../components/VehicleOfferListItem/VehicleOfferListItem";
import {CustomerTypeContext} from "../../context/customer-type-context";
import {goVehisService} from "../../utils/axios";
import {sortTypes} from "./SortTypes";
import ConvertUtils from "../../utils/ConvertUtils";
import OfferPagination from "./OfferPagination";
import NoOffersFound from "./NoOffersFound";
import OfferSkeletonCard from "../../components/VehicleOfferListItem/OfferSkeletonCard";

const DEFAULT_PAGE_SIZE = 12;

function OfferList(props) {

    const [offers, setOffers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [customerType] = useContext(CustomerTypeContext);
    const history = useHistory();
    const prevPageRef = useRef(null);

    const getUrlParams = () => new URLSearchParams(props.location.search);
    const currentPage = parseInt(getUrlParams().get("page") || "1", 10);
    const pageSize = parseInt(getUrlParams().get("limit") || DEFAULT_PAGE_SIZE, 10);
    const totalPages = (typeof props.offersNumber === "number" && props.offersNumber > 0)
        ? Math.ceil(props.offersNumber / pageSize)
        : 0;

    useEffect(() => {
        setLoading(true);

        // When landing on a paginated page (2, 3, …) scroll to the first offer
        // instead of the top / filters. Filter apply and clear always reset to
        // page 1 (no page param), so those still scroll to the very top.
        const isPageNavigation = currentPage > 1 && prevPageRef.current !== currentPage;
        prevPageRef.current = currentPage;

        if (isPageNavigation) {
            // Wait for the filters to collapse and reflow before measuring the target.
            requestAnimationFrame(() => requestAnimationFrame(() => {
                const list = document.getElementById("offers-list");
                if (list) {
                    const y = list.getBoundingClientRect().top + window.pageYOffset - 12;
                    window.scrollTo(0, Math.max(0, y));
                } else {
                    window.scrollTo(0, 0);
                }
            }));
        } else {
            window.scrollTo(0, 0);
        }

        // Remember the last filters used on the list — the offer page uses
        // them to pick "Polecamy podobne oferty" recommendations.
        const filterParams = getUrlParams();
        ["page", "limit", "start", "sortingType", "customerType", "ds", "filterClicked", "extended"]
            .forEach(key => filterParams.delete(key));
        sessionStorage.setItem("lastOfferListFilters", filterParams.toString());

        const urlSearchParams = getUrlParams();

        if (!urlSearchParams.get("sortingType")) {
            urlSearchParams.set("sortingType", sortTypes[8].value);
        }

        urlSearchParams.set("start", ((currentPage - 1) * pageSize).toString());
        urlSearchParams.set("limit", pageSize.toString());
        urlSearchParams.set("customerType", customerType);
        urlSearchParams.delete("page");

        goVehisService.get("/vehicles?" + urlSearchParams.toString()).then(response => {
            setOffers(response.data);
            setLoading(false);
        }).catch(() => {
            setLoading(false);
        });
    }, [props.location.search, customerType]);

    const handlePageChange = (page) => {
        if (page < 1 || (totalPages > 0 && page > totalPages)) return;
        const urlSearchParams = getUrlParams();
        urlSearchParams.set("page", page.toString());
        history.push(props.location.pathname + "?" + urlSearchParams.toString());
    };

    const handlePageSizeChange = (size) => {
        const urlSearchParams = getUrlParams();
        urlSearchParams.set("limit", size.toString());
        urlSearchParams.set("page", "1");
        history.push(props.location.pathname + "?" + urlSearchParams.toString());
    };

    if (!loading && offers.length === 0) {
        return (
            <div id="content">
                <div className="container">
                    <NoOffersFound locationPathname={props.location.pathname} />
                </div>
            </div>
        );
    }

    if (loading && offers.length === 0) {
        return (
            <div id="content">
                <div className="container">
                    <div id="offers-list" className={props.viewType}>
                        {Array.from({ length: pageSize }, (_, i) => (
                            <OfferSkeletonCard key={i} />
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="content">
            <div className="container">
                <div id="offers-list" className={props.viewType + (loading ? " offers-loading" : "")}>
                    {offers.map(offer => (
                        <VehicleOfferListItem
                            isSliderOffer={false}
                            showRibbons={props.viewType === "grid-view"}
                            key={offer.uuid}
                            url={ConvertUtils.stringToUrl(offer.brandName.replace("/", "") + "/" + offer.versionName + "/" + offer.vehicleIds[0])}
                            offer={offer}
                        />
                    ))}
                </div>
                <OfferPagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    pageSize={pageSize}
                    onPageChange={handlePageChange}
                    onPageSizeChange={handlePageSizeChange}
                />
            </div>
        </div>
    );
}

export default withRouter(OfferList);
